import React from "react";
import {FunctionComponent} from "react";
import {css} from "@emotion/react";

import {listUnStyled} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {Promotion} from "./Promotion";

interface IProps {
    promotions: {
        description: string | null;
        id: number;
        name: string;
        type: number;
    }[];
    vendorId: number;
    offerId?: number;
    propertyId?: number;
    isAutoresponderEnabled: boolean;
    isSaleOverLimit?: boolean;
}

export const Promotions: FunctionComponent<IProps> = (props) => {
    const {promotions} = props;

    return (
        <>
            <Text as="h2" variant="headline_4" css={promotionsHeaderStyle}>
                Promocje
            </Text>

            <ul css={listUnStyled}>
                {promotions.map((promotion) => (
                    <Promotion
                        key={promotion.id}
                        promotion={promotion}
                        vendorId={props.vendorId}
                        offerId={props.offerId}
                        propertyId={props.propertyId}
                        isAutoresponderEnabled={props.isAutoresponderEnabled}
                        isSaleOverLimit={props.isSaleOverLimit}
                    />
                ))}
            </ul>
        </>
    );
};

const promotionsHeaderStyle = css`
    margin: 0 0 2.4rem 0;
`;
import React from "react";
import {FunctionComponent} from "react";
import {css} from "@emotion/react";

import {listUnStyled} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {Promotion} from "./Promotion";

interface IProps {
    promotions: {
        description: string | null;
        id: number;
        name: string;
        type: number;
    }[];
    vendorId: number;
    offerId?: number;
    propertyId?: number;
    isAutoresponderEnabled: boolean;
    isSaleOverLimit?: boolean;
}

export const Promotions: FunctionComponent<IProps> = (props) => {
    const {promotions} = props;

    return (
        <>
            <Text as="h2" variant="headline_4" css={promotionsHeaderStyle}>
                Promocje
            </Text>

            <ul css={listUnStyled}>
                {promotions.map((promotion) => (
                    <Promotion
                        key={promotion.id}
                        promotion={promotion}
                        vendorId={props.vendorId}
                        offerId={props.offerId}
                        propertyId={props.propertyId}
                        isAutoresponderEnabled={props.isAutoresponderEnabled}
                        isSaleOverLimit={props.isSaleOverLimit}
                    />
                ))}
            </ul>
        </>
    );
};

const promotionsHeaderStyle = css`
    margin: 0 0 2.4rem 0;
`;
